import { ApolloProvider } from "@apollo/client";
import { canUseDOM } from "exenv";
import type { Root } from "react-dom/client";
import { createRoot } from "react-dom/client";
import { IntlProvider } from "react-intl";
import { Provider as ReduxProvider } from "react-redux";

import { getSingletonStore } from "../components/stores/store";

import { client } from "./kibelaClient2";

let modalContainer: Element | null = null;
let root: Root | null = null;

function getModalContainer(): Element {
  if (!canUseDOM) {
    throw new Error("awaitable modals are only available on DOM");
  }

  return modalContainer || (modalContainer = document.createElement("div"));
}

export function closeModal() {
  if (!canUseDOM) {
    throw new Error("awaitable modals are only available on DOM");
  }

  root?.unmount();
}

// TODO: Use createElement function that is defined in components.ts
//       to apply betaFeatures and so on.
export function renderModal(modalElement: React.ReactElement) {
  const store = getSingletonStore();
  const component = modalElement.props.intl ? (
    <IntlProvider
      locale={modalElement.props.intl.locale}
      messages={modalElement.props.intl.messages}
      textComponent="span"
    >
      {modalElement}
    </IntlProvider>
  ) : (
    modalElement
  );

  root = createRoot(getModalContainer()!);
  root.render(
    <ApolloProvider client={client}>
      <ReduxProvider store={store}>{component}</ReduxProvider>
    </ApolloProvider>,
  );
}
